export const getDurations = () => {
  const items = [];
  for (let i = 1; i <= 3; i++) {
    items.push({ label: `${i} ${i === 1 ? 'month' : 'months'}`, value: i });
  }
  return items;
};
